var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCopyIcon = function SvgCopyIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00014 14.5716H5.143C4.68834 14.5716 4.2523 14.391 3.93081 14.0695C3.60932 13.748 3.42871 13.3119 3.42871 12.8573V5.143C3.42871 4.68834 3.60932 4.2523 3.93081 3.93081C4.2523 3.60932 4.68834 3.42871 5.143 3.42871H12.8573C13.3119 3.42871 13.748 3.60932 14.0695 3.93081C14.391 4.2523 14.5716 4.68834 14.5716 5.143V6.00014M11.143 9.42871H18.8573C19.8041 9.42871 20.5716 10.1962 20.5716 11.143V18.8573C20.5716 19.8041 19.8041 20.5716 18.8573 20.5716H11.143C10.1962 20.5716 9.42871 19.8041 9.42871 18.8573V11.143C9.42871 10.1962 10.1962 9.42871 11.143 9.42871Z",
    stroke: "#E5B611",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCopyIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/copyIcon.4afaa13456804466fe169ff5b5fbba70.svg";